module.exports = __webpack_public_path__ + "media/images/my_apps/android_badge_localized_english-28bdf524d80d2c084c0c3124f68f864f.png";